import { Swiper, Navigation, A11y, Pagination, Thumbs, Autoplay, Scrollbar } from 'swiper';

export default () => {
  Swiper.use([Navigation, A11y, Pagination, Thumbs, Autoplay, Scrollbar]);

  const defaultConfig = {
    direction: 'horizontal',
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    allowTouchMove: false,
  };

  // Configuration overrides
  const configurations = new Map();

  configurations.set('upsell-slider', {
    direction: 'horizontal',
    centeredSlides: false,
    preloadImages: true,
    loop: false,
    updateOnImagesReady: true,
    slidesPerView: 'auto',
    effect: 'fade',
    a11y: true,
    navigation: {
      nextEl: '.swiper-button-next-upsell',
      prevEl: '.swiper-button-prev-upsell',
    },
  });

  configurations.set('brands-slideshow', {
    autoplay: true,
    loop: true,
    slidesPerView: 3,
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
    navigation: false,
  });

  const allPreviewSliderEls = document.querySelectorAll(
    '.js-slider[data-slider-type="preview-item-slider"]',
  );

  allPreviewSliderEls.forEach((slider, index) => {
    slider.setAttribute('data-config', `preview-item-slider${index}`);
    const currentSlider = document.querySelector(
      `.js-slider[data-config="preview-item-slider${index}"]`,
    );

    configurations.set(`preview-item-slider${index}`, {
      slidesPerView: 1.5,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          allowTouchMove: false,
          spaceBetween: 0,
          slidesPerView: 2.5,
        },
        1200: {
          spaceBetween: 0,
          slidesPerView: 3,
          allowTouchMove: false,
        },
        1400: {
          spaceBetween: 0,
          slidesPerView: 3,
          allowTouchMove: false,
        },
      },
      navigation: {
        nextEl: currentSlider.querySelector('.js-slider--next'),
        prevEl: currentSlider.querySelector('.js-slider--prev'),
      },
    });
  });

  configurations.set('preview-item-slider-scrollbar', {
    slidesPerView: 1.5,
    spaceBetween: 20,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: false,
    },
    navigation: {
      nextEl: '.js-slider--next-alt',
      prevEl: '.js-slider--prev-alt',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        allowTouchMove: false,
        slidesPerView: 2.5,
        spaceBetween: 0,
      },
      1200: {
        spaceBetween: 0,
        slidesPerView: 3,
      },
      1400: {
        spaceBetween: 0,
        slidesPerView: 3,
      },
    },
  });

  configurations.set('favorites-slideshow', {
    slidesPerView: 1.5,
    breakpoints: {
      1024: {
        slidesPerView: 3,
      },
    },
    spaceBetween: 20,
  });

  configurations.set('week-item-slider', {
    observer: true,
    slidesPerView: 1.5,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 2.5,
        spaceBetween: 0,
      },
      1200: {
        spaceBetween: 0,
        slidesPerView: 3,
      },
      1400: {
        spaceBetween: 0,
        slidesPerView: 3,
      },
    },
  });

  configurations.set('related-collections-slideshow', {
    direction: 'horizontal',
    preloadImages: true,
    updateOnImagesReady: true,
    watchSlidesVisibility: true,
    spaceBetween: 20,
    slidesPerView: 'auto',
    effect: 'fade',
    a11y: true,
    navigation: {
      nextEl: '.js-slider--next',
      prevEl: '.js-slider--prev',
    },
    breakpoints: {
      1024: {
        allowTouchMove: false,
        spaceBetween: 0,
      },
      1200: {
        spaceBetween: 0,
      },
      1450: {
        spaceBetween: 0,
      },
    },
  });

  configurations.set('product-thumbs-slider', {
    direction: 'horizontal',
    slidesPerGroup: 2,
    shortSwipes: false,
    preloadImages: true,
    spaceBetween: 20,
    updateOnImagesReady: true,
    slidesPerView: 4,
    allowTouchMove: false,
    watchSlidesVisibility: true,
    watchOverflow: true,
    watchSlidesProgress: true,
    a11y: false,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '.swiper-button-next--thumb',
      prevEl: '.swiper-button-prev--thumb',
    },
  });

  configurations.set('product-slider', {
    direction: 'horizontal',
    centeredSlides: false,
    preloadImages: true,
    loop: false,
    spaceBetween: 10,
    updateOnImagesReady: true,
    slidesPerView: 1,
    effect: 'fade',
    a11y: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '.swiper-button-next--product',
      prevEl: '.swiper-button-prev--product',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  configurations.set('collection-product-slider', {
    observer: true,
    observeParents: true,
    direction: 'horizontal',
    preloadImages: true,
    spaceBetween: 20,
    updateOnImagesReady: true,
    watchSlidesVisibility: true,
    slidesPerView: 1.5,
    effect: 'fade',
    a11y: true,
    loop: false,
    navigation: {
      nextEl: '.js-slider--next',
      prevEl: '.js-slider--prev',
    },
    breakpoints: {
      768: {
        spaceBetween: 20,
        slidesPerView: 2.4,
      },
      1024: {
        spaceBetween: 0,
        touchRatio: 0,
        allowTouchMove: false,
        slidesPerView: 3.4,
      },
      1200: {
        spaceBetween: 0,
        slidesPerView: 3.4,
        allowTouchMove: false,
      },
      1450: {
        spaceBetween: 0,
        slidesPerView: 4,
        allowTouchMove: false,
      },
    },
  });

  configurations.set('related-products-slider', {
    direction: 'horizontal',
    preloadImages: true,
    spaceBetween: 10,
    updateOnImagesReady: true,
    watchSlidesVisibility: true,
    slidesPerView: 2,
    effect: 'fade',
    a11y: true,
    navigation: {
      nextEl: '.js-slider--next',
      prevEl: '.js-slider--prev',
    },
    breakpoints: {
      1400: {
        slidesPerView: 3,
      },
    },
  });

  // Init sliders
  const sliders = [...document.querySelectorAll('.js-slider')];
  sliders.forEach((sliderEl) => {
    let config = configurations.get(sliderEl.dataset.config);
    if (!config) {
      config = defaultConfig;
    }
    window.slider = {
      ...window.slider,
      [sliderEl.dataset.config]: new Swiper(sliderEl.querySelector('.swiper-container'), config),
    };
  });

  if (window.slider !== undefined) {
    if (window.slider['product-slider'] && window.slider['product-thumbs-slider']) {
      const mainSlider = window.slider['product-slider'];
      const thumbSlider = window.slider['product-thumbs-slider'];

      mainSlider.thumbs.swiper = thumbSlider;
      mainSlider.thumbs.init();
    }
  }
};
